// import React from "react";
import "./EventOneHealth.scss";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const Health = () => {
  const options = {
    items: 3,
    dots: false,
    loop: true,
    margin: 30,
    nav: true,
    smartSpeed: 1500,
    autoplay: true,
    autoplayTimeout: 5000,
    responsive: {
      // Define breakpoints and the number of items to show at each breakpoint
      0: {
        items: 1,
        nav: false,
      },
      768: {
        items: 2,
        nav: false,
      },
      992: {
        items: 3,
      },
      1199: {
        items: 3,
      },
    },
  };
  return (
    <div className="Health-events">
      <div className="container">
        <div className="Health_inner">
          <div className="section_header">
            <div className="left">
              <div className="icon-main">
                <div className="icon">
                  <span class="material-symbols-outlined">ice_skating</span>
                </div>
              </div>
              <div>
                <h2 className="title">Ice Hockey</h2>
              </div>
            </div>
            <div className="right">
              <button className="event_one_viewall_button">View All</button>
            </div>
          </div>

          <div div className="event-container">
            <OwlCarousel className="owl-theme my_owl_carousel" {...options}>
              <div className="event-card">
                <div className="image-container">
                  <img
                    src="./assets/img/eventify/skating1.jpg"
                    className="event-image"
                  />
                  <p>Gurgaon Ambience Ice Hockey 2025</p>
                  <div className="badge">ICE SKATING</div>
                </div>
                <div className="event-details">
                  <div className="text">
                    <span class="material-symbols-outlined">
                      calendar_month
                    </span>
                    <h6>1 June 2025</h6>
                  </div>
                  <div className="text">
                    <span class="material-symbols-outlined">location_on</span>
                    <h6>Gurgaon</h6>
                  </div>
                </div>
                <div className="buy-now">
                  <h6 className="price">₹499</h6>
                  <h6 className="buy_now">Buy now</h6>
                </div>
              </div>
              <div className="event-card">
                <div className="image-container">
                  <img
                    src="./assets/img/eventify/skating2.jpg"
                    className="event-image"
                  />
                  <p>Delhi vs Chandigarh Ice Hockey 2025</p>
                  <div className="badge">ICE SKATING</div>
                </div>
                <div className="event-details">
                  <div className="text">
                    <span class="material-symbols-outlined">
                      calendar_month
                    </span>
                    <h6>1 June 2025</h6>
                  </div>
                  <div className="text">
                    <span class="material-symbols-outlined">location_on</span>
                    <h6>Delhi</h6>
                  </div>
                </div>
                <div className="buy-now">
                  <h6 className="price">₹499</h6>
                  <h6 className="buy_now">Buy now</h6>
                </div>
              </div>
              <div className="event-card">
                <div className="image-container">
                  <img
                    src="./assets/img/eventify/skating3.jpg"
                    className="event-image"
                  />
                  <p>Inter State Ice Hockey Championship 2025</p>
                  <div className="badge">ICE SKATING</div>
                </div>
                <div className="event-details">
                  <div className="text">
                    <span class="material-symbols-outlined">
                      calendar_month
                    </span>
                    <h6>1 June 2025</h6>
                  </div>
                  <div className="text">
                    <span class="material-symbols-outlined">location_on</span>
                    <h6>Mumbai</h6>
                  </div>
                </div>
                <div className="buy-now">
                  <h6 className="price">₹499</h6>
                  <h6 className="buy_now">Buy now</h6>
                </div>
              </div>
            </OwlCarousel>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Health;
